export const ROLES = {
  ADMIN: "admin", // 系统管理员
  OPERATOR: "operator", // 运营人员
  EDITOR: "editor", // 内容编辑
  VIEWER: "viewer", // 普通查看者
} as const;
